import {
  BRAND_LINKS,
  SUPPORT_EMAIL,
  SUPPORT_WHATSAPP_DISPLAY,
} from "@tami/core";
import type { CopyShape } from "@tami/core/intl";

import {
  PRIVACY_POLICY_DOCUMENT,
  TERMS_OF_USE_DOCUMENT,
  legalDocumentPath,
} from "@/lib/legal/legal-documents";

import type { BIO_COPY_PT_BR } from "../bio-site.copy";

// `DEMO_BASE_HREF` não vem de `../bio-site.copy`: o import seria circular (o
// copy em português importa este arquivo). O destino é o mesmo, "/demo".
const DEMO_BASE_HREF = "/demo";

export const BIO_COPY_ES_ES: CopyShape<typeof BIO_COPY_PT_BR> = {
  tagline: {
    before: "La herramienta que ",
    highlight: "organiza",
    after: " tu vida de creator.",
  },
  social: [
    { key: "instagram", ...BRAND_LINKS.instagram },
    { key: "youtube", ...BRAND_LINKS.youtube },
  ],
  cta: {
    label: "Crear mi cuenta",
    description: "Gratis para empezar",
    href: BRAND_LINKS.signUp.href,
  },
  links: [
    {
      key: "demo",
      label: "Ver Tãmi en acción",
      description: "Un tour por el producto, sin crear cuenta",
      href: DEMO_BASE_HREF,
      external: false,
    },
    {
      key: "pricing",
      label: "Planes y precios",
      description: undefined,
      href: "/es#pricing",
      external: false,
    },
    {
      key: "site",
      label: "Conoce Tãmi",
      description: undefined,
      href: BRAND_LINKS.site.href,
      external: false,
    },
  ],
  features: [
    { key: "agenda", label: "Calendario" },
    { key: "conteudo", label: "Contenido" },
    { key: "campanhas", label: "Campañas" },
    { key: "financas", label: "Finanzas" },
    { key: "whatsapp", label: "WhatsApp" },
  ],
  collab: {
    title: "¿Gestionas a varios creators?",
    description: {
      before: "En el modo Collab, una sola cuenta se encarga de ",
      highlight: "todos",
      after:
        " los creators de la casa: la agenda, las campañas y las finanzas de cada uno, en el mismo sitio.",
    },
    ctaLabel: "Habla con nosotros",
  },
  support: {
    title: "¿Necesitas ayuda?",
    whatsappLabel: SUPPORT_WHATSAPP_DISPLAY,
    whatsappHref: BRAND_LINKS.supportWhatsApp.href,
    emailLabel: SUPPORT_EMAIL,
    emailHref: BRAND_LINKS.supportEmail.href,
  },
  footer: {
    terms: { label: "Términos de uso", href: legalDocumentPath(TERMS_OF_USE_DOCUMENT, "es-ES") },
    privacy: {
      label: "Política de privacidad",
      href: legalDocumentPath(PRIVACY_POLICY_DOCUMENT, "es-ES"),
    },
  },
};
